import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Container } from 'reactstrap';
import CommunitySetUp from './forms/communitysetup';
import AppConfig from './forms/appconfig';
import GetKnowlegeable from './forms/getknowlegeable';
import SurveyService from './forms/SurveyService';
import Nearme from './forms/nearme';
import Finish from './forms/finish';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Tour from 'reactour';
import { aCommunitySetUpTour } from '../data/config';
import ReactGA from 'react-ga';

class SmartSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'appconfig-tab',
      bTour: false
    };
  }

  toggle = (activeTab) => {
    if (this.state.activeTab !== activeTab) {
      this.setState({ activeTab });
      ReactGA.event({
        category: 'Smart Setup',
        action: `Clicked on ${activeTab}`
      });
    }
  }

  componentDidMount = () => {
    let bCommunitySetUpTour = localStorage.getItem('bCommunitySetUpTour');
    if (bCommunitySetUpTour === null) {
      localStorage.setItem('bCommunitySetUpTour', true);
    }
    this.setState({
      bTour: localStorage.getItem('bCommunitySetUpTour') === 'true'
    });
    // console.log(window.location);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  toggleActive = (activeTab) => {
    this.setState({ activeTab });
    // document.getElementById(activeTab).click();
    if (this.props.community) {
      if (this.props.community.key_value_pairs) {
        let oSections = JSON.parse(this.props.community.key_value_pairs), aMenus = ['Setup'];
        let dashboardData = oSections.dashboard;
        for (let i in dashboardData) {
          aMenus.push(dashboardData[i].value);
        }
        this.props.testFn(aMenus);
      }
    }
  }

  onTourClose = () => {
    this.setState({ bTour: false });
    localStorage.setItem('bCommunitySetUpTour', false);
  }

  resetTour = () => {
    localStorage.setItem('bCommunitySetUpTour', true);
    this.setState({ bTour: true });
  }

  render() {
    return (
      <Container fluid className="my-4">
        <Row>
          <Col className="text-right">
            <i title="Help" className="fa fa-info smart-setup-help-btn" onClick={this.resetTour}></i>
          </Col>
        </Row>
        <Row>
          <Col>
            <Nav tabs className="sstab">
              <NavItem className={classnames({ active: this.state.activeTab === 'appconfig-tab' })}>
                <NavLink onClick={() => { this.toggle('appconfig-tab'); }} >
                  Dashboard Configuration
                  <div className="nav-arrow"></div>
                </NavLink>
              </NavItem>
              <NavItem className={classnames({ active: this.state.activeTab === 'home-tab' })}>
                <NavLink onClick={() => { this.toggle('home-tab'); }} >
                  Community Setup
                  <div className="nav-wedge"></div>
                  <div className="nav-arrow"></div>
                </NavLink>
              </NavItem>
              <NavItem className={classnames({ active: this.state.activeTab === 'getknowlegeable-tab' })}>
                <NavLink onClick={() => { this.toggle('getknowlegeable-tab'); }} >
                  Get Information
                  <div className="nav-wedge"></div>
                  <div className="nav-arrow"></div>
                </NavLink>
              </NavItem>
              <NavItem className={classnames({ active: this.state.activeTab === 'service-tab' })}>
                <NavLink onClick={() => { this.toggle('service-tab'); }} >
                  Get Involved
                  <div className="nav-wedge"></div>
                  <div className="nav-arrow"></div>
                </NavLink>
              </NavItem>
              <NavItem className={classnames({ active: this.state.activeTab === 'nearme-tab' })} >
                <NavLink onClick={() => { this.toggle('nearme-tab'); }} >
                  Nearme
                  <div className="nav-wedge"></div>
                  <div className="nav-arrow"></div>
                </NavLink>
              </NavItem>
              <NavItem className={classnames({ active: this.state.activeTab === 'finish-tab' })} >
                <NavLink onClick={() => { this.toggle('finish-tab'); }} >
                  Publish
                  <div className="nav-wedge"></div>
                  <div className="nav-arrow"></div>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="appconfig-tab">
                <Row>
                  <Col>
                    {this.state.activeTab === 'appconfig-tab' && <AppConfig configTab={this.toggleActive} />}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="home-tab">
                <Row>
                  <Col>
                    {this.state.activeTab === 'home-tab' && <CommunitySetUp configTab={this.toggleActive} />}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="getknowlegeable-tab">
                <Row>
                  <Col>
                    {this.state.activeTab === 'getknowlegeable-tab' && <GetKnowlegeable configTab={this.toggleActive} />}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="service-tab">
                <Row>
                  <Col>
                    {this.state.activeTab === 'service-tab' && <SurveyService configTab={this.toggleActive} />}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="nearme-tab">
                <Row>
                  <Col>
                    {this.state.activeTab === 'nearme-tab' && <Nearme configTab={this.toggleActive} />}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="finish-tab">
                <Row>
                  <Col>
                    {this.state.activeTab === 'finish-tab' && <Finish /> }
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
        <Tour 
          steps={aCommunitySetUpTour}
          isOpen={this.state.bTour}
          onRequestClose = {this.onTourClose}
          disableInteraction = {true}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => {
    return { community: state.community };
}

export default connect(mapStateToProps)(SmartSetup)